// src/components/auth/LoginPage.jsx
import React, { useState } from "react";

import "../../css/LoginPage.css";
import { useAuth } from "../../contexts/AuthContext";
import MarketingIllustration from "../../assets/TestingLogin.svg";
// TODO: Uncomment these imports when implementing OAuth
// import googleIcon from "../../assets/images/login/googleLogo.png";
// import linkedinIcon from "../../assets/images/login/linkedinLogo.png";
import skillMatchLogo from "../../assets/images/login/skillMatchLogo.svg";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Get login function and OAuth URLs from context
  const { login /* getGoogleLoginUrl, getLinkedinLoginUrl */ } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage("Please enter both email and password");
      return;
    }
    setErrorMessage("");
    setIsLoading(true);
    try {
      // Call login - this updates AuthContext state (currentUser, isProfileComplete)
      // The RouteManager component will react to this state change and handle navigation.
      await login(email, password);
      console.log(
        "Login request successful, AuthContext state updated. RouteManager will handle redirect."
      );
    } catch (error) {
      console.error("Login error caught in LoginPage:", error);
      setErrorMessage(
        error.response?.data?.detail ||
          error.message ||
          "Login failed. Please check your credentials."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // TODO: Uncomment and implement OAuth handlers when ready
  /*
  // --- OAuth Handlers ---
  const handleGoogleLogin = () => {
    const url = getGoogleLoginUrl();
    if (url) window.location.href = url;
    else console.error("Google Login URL is not configured.");
  };

  const handleLinkedInLogin = () => {
    const url = getLinkedinLoginUrl();
    if (url) window.location.href = url;
    else console.error("LinkedIn Login URL is not configured.");
  };

  const handleTwitterLogin = () => {
    setErrorMessage("Twitter login is not available yet");
  };
  */

  // --- Render ---
  return (
    // Ensure class names match your CSS
    <div className="login-container">
      {/* Left Section */}
      <div className="login-form-section">
        <div className="logo-container">
          <img
            src={skillMatchLogo}
            alt="SkillMatchAI Logo"
            className="logo-image"
          />
        </div>
        <div className="form-container">
          <h1 className="form-title">Sign In to your account</h1>
          <p className="form-subtitle">Enter your details to sign in</p>
          {errorMessage && <div className="error-message">{errorMessage}</div>}

          {/* TODO: Uncomment Social Login Buttons when OAuth is implemented */}
          {/*
          <div className="social-login-buttons">
            <button
              className="social-button google"
              onClick={handleGoogleLogin}
              type="button"
            >
              <img src={googleIcon} alt="Google" className="social-icon" />
              <span>Google</span>
            </button>
            <button
              className="social-button linkedin"
              onClick={handleLinkedInLogin}
              type="button"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
              <span>LinkedIn</span>
            </button>
          </div>
          <div className="divider">
            <div className="divider-line"></div>
            <span className="divider-text">OR</span>
            <div className="divider-line"></div>
          </div>
          */}

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="email">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                placeholder="you@example.com"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <input
                type="password"
                id="password"
                placeholder="Enter your password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <div className="form-options">
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="remember"
                  className="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label htmlFor="remember" className="checkbox-label">
                  Keep me logged in
                </label>
              </div>
              <a href="/forgot-password" className="forgot-password">
                Forgot password?
              </a>
            </div>
            <button
              type="submit"
              className="signin-button"
              disabled={isLoading}
            >
              {isLoading ? "Signing In..." : "Sign In"}
            </button>
          </form>
          <div className="signup-prompt">
            <span>Don't have an account? </span>
            <a href="/signup" className="signup-link">
              Sign Up
            </a>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className="marketing-section">
        <img
          src={MarketingIllustration}
          alt="SkillMatchAI marketing illustration"
          className="marketing-svg"
        />
      </div>
    </div>
  );
};

export default LoginPage;
